import BoltIcon from '@mui/icons-material/Bolt';
import { Box, Typography, useTheme } from '@mui/material';
import useAppShellSx from '../../hooks/useAppShellSx';
import useSidebarTransition from '../../hooks/useSidebarTransition';

export default function SidebarBrand({ collapsed, organisationName, onNavigateHome }) {
  const theme = useTheme();
  const { sidebar, sidebarType } = useAppShellSx();
  const { getLabelSx, getIconBoxSx, getBrandLayoutSx } = useSidebarTransition();

  return (
    <Box
      sx={{
        ...getBrandLayoutSx(collapsed),
        pt: 2,
        pb: collapsed ? 1.5 : 2,
        display: 'flex',
        alignItems: 'center',
        cursor: onNavigateHome ? 'pointer' : 'default',
        transition: theme.transitions.create('padding', {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.standard,
        }),
      }}
      onClick={onNavigateHome}
    >
      <Box
        sx={{
          ...getIconBoxSx(collapsed),
          borderRadius: 2,
          bgcolor: sidebar.accent,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <BoltIcon
          sx={{
            color: sidebar.badgeForeground,
            fontSize: 20,
          }}
        />
      </Box>

      <Box sx={getLabelSx(collapsed)}>
        <Typography sx={sidebarType.brandTitle}>Machadalo</Typography>
        <Typography sx={{ ...sidebarType.brandSubtitle, mt: 0.25 }}>
          {organisationName || 'Dashboard'}
        </Typography>
      </Box>
    </Box>
  );
}
